import { render, staticRenderFns } from "./mock-calculate.vue?vue&type=template&id=07216560&scoped=true&"
import script from "./mock-calculate.vue?vue&type=script&lang=js&"
export * from "./mock-calculate.vue?vue&type=script&lang=js&"
import style0 from "./mock-calculate.vue?vue&type=style&index=0&id=07216560&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07216560",
  null
  
)

export default component.exports